/**
 * Wraps a promise-returning function and ensures it is called without awaiting the result.
 * Use when you want to fire and forget a promise without handling its result or error.
 */
export const noawait = (fn: () => Promise<void>) => {
  void fn();
};
